export default {
    web_hooks_id: 'ID',
    web_hooks_name: 'Nombre',
    web_hooks_action: 'Url',
    web_hooks_event_type: 'Tipo de Evento',
    web_hooks_status: 'Estado',
    web_hooks_status_active: 'Activo',
    web_hooks_status_inactive: 'Inactivo',
    web_hooks_created_on: 'Creado en',
    web_hooks_updated_on: 'Actualizado en',
    web_hooks_edit: 'Editar',
    web_hooks_delete: 'Eliminar',
    web_hooks_add_new: 'Agregar Nuevo Webhook',
};
